import React from "react";
import frontend from "../assets/frontend.svg";
import backend from "../assets/backend.svg";
import database from "../assets/database.svg";

export default [
	{
		id: 1,
		icon: <img className="service-icon" src={frontend} alt="icon" />,
		title: "Frontend",
		text: `JavaScript • React • CSS • HTML • Animations`,
	},
	{
		id: 2,
		icon: <img className="service-icon" src={backend} alt="icon" />,
		title: "Backend & Cloud",
		text: `Node.js • AWS`,
	},
	{
		id: 3,
		icon: <img className="service-icon" src={database} alt="icon" />,
		title: "API & Database",
		text: `REST • GraphQL • SQL`,
	},
];
